import { useQuery } from '@tanstack/react-query';
import { companyApi } from '../companyApi';
import { QueryKey } from '@shared/config';

export const useGetCompaniesTypes = () => {
  return useQuery({
    queryKey: [QueryKey.GET_COMPANY_TYPES],
    queryFn: () => companyApi.getCompanyTypes(),
  });
};
